var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards-group width-100"},_vm._l((_vm.projects),function(project,indx){return _c('div',{key:`${project.id}__${indx}`,staticClass:"mr-3 mb-2 card"},[_c('ProjectDetailsCard',{attrs:{"isVirtual":_vm.isVirtual,"project":project,"fetchData":false}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }